import { render, staticRenderFns } from "./FormulateChips.vue?vue&type=template&id=70e93554"
import script from "./FormulateChips.vue?vue&type=script&lang=js"
export * from "./FormulateChips.vue?vue&type=script&lang=js"
import style0 from "./FormulateChips.vue?vue&type=style&index=0&id=70e93554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports